const INIT_STATE = {
  isModalActive: false,
  formDataId: '',
  number: '',
  message: '',
}

export function SmsModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'SMS_MODAL_RESET':
      return { ...INIT_STATE };
    case 'SMS_MODAL_SHOW':
      return { ...state, isModalActive: true };
    case 'SMS_MODAL_HIDE':
      return { ...state, isModalActive: false };
    case 'SMS_MODAL_TOGGLE':
      return { ...state, isModalActive: !state.isModalActive };
    case 'SMS_MODAL_INITIALIZE':
      return { ...state, ...action.payload, isModalActive: true }
    case 'SET_SMS_NUMBER':
      return { ...state, number: action.payload }
    case 'SET_SMS_MESSAGE':
      return { ...state, message: action.payload }
    case 'SET_SMS_CONTENT':
      return { ...state, ...action.payload }

    default:
      return state;
  }
}